// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"_3mSn7","share-button":"_32mKB","fb":"_3BCKl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareModal/FacebookShareButton.scss
// module id = ./src/components/ShareModal/FacebookShareButton.scss
// module chunks = 4